import React from 'react';
import './TextField.css';
import { svgIcons } from '../../../style/fonts/SvgIcons';

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    leftLabel?: string;
    labelClass?: string;
    fieldClass?: string;
    required?: boolean;
    icon?: any
    fieldIcon?: any
    class?: any
    min?:any
}

const TextField: React.FC<TextFieldProps> = ({
    label,
    leftLabel,
    labelClass = '',
    type = 'text',
    min,
    id,
    value,
    checked,
    fieldClass = '',
    placeholder,
    onChange,
    required,
    icon,
    fieldIcon,
    ...fieldProps
}) => {
    return (
        <div className={`${leftLabel ? 'd-md-flex w-100 justify-content-between align-items-center ' : ''}`}>
            {label || leftLabel ?
                <label className={`input-label text-nowrap  ${labelClass} ${required ? 'required' : ''} ${leftLabel ? 'w-50' : ''}`}>
                    <div>
                        <span className=''>{icon}</span>{label}{leftLabel}
                        {required && <span className="required-star text-danger ms-1">*</span>}
                    </div>
                </label>
                : null}
            <div className={`position-relative ${leftLabel ? 'w-50' : ''}`}>
                {fieldIcon === true &&
                    <i className='icon2 position-absolute ms-2' style={{ top: '9px' }}>{svgIcons.dollarIcon}</i>
                }
                <input
                    type={type}
                    className={`${type !== 'checkbox' ? 'form-control form-control-solid default-inputs' : ''} ${fieldIcon === true ? 'ps-4' : ''} ${fieldClass} `}
                    placeholder={placeholder}
                    onChange={onChange}
                    id={id}
                    min={min}
                    value={value}
                    checked={checked}
                    {...fieldProps}
                />
            </div>
        </div>
    );
}

export default TextField;
